module.exports = __webpack_public_path__ + "static/img/3.cfbe1c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/sp/3.png
// module id = +QgW
// module chunks = 0